import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";

/**
 * Where to land after sign-in: the path ProtectedRoute stashed in the OIDC state. Same-origin
 * paths only — never an absolute or protocol-relative ("//host") URL, never back into /auth/.
 */
function returnPath(state: unknown): string {
    const raw = (state as { returnTo?: unknown } | null | undefined)?.returnTo;
    if (typeof raw !== "string" || !raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/auth/")) {
        return "/";
    }
    return raw;
}

export function CallbackPage() {
    const auth = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!auth.isLoading && auth.isAuthenticated) {
            navigate(returnPath(auth.user?.state), { replace: true });
        }
    }, [auth.isLoading, auth.isAuthenticated, auth.user, navigate]);

    if (auth.error) {
        return (
            <div className="flex min-h-screen items-center justify-center p-8">
                <div className="text-center">
                    <h1 className="text-lg font-semibold text-destructive">Sign-in failed</h1>
                    <p className="mt-2 text-sm text-muted-foreground">{auth.error.message}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="flex min-h-screen items-center justify-center">
            <p className="text-sm text-muted-foreground">Completing sign-in…</p>
        </div>
    );
}
